(function () {
  'use strict';

  /* @ngdoc object
   * @name account.billing
   * @description
   *
   */
  angular
    .module('account.billing', [
      'ui.router'
    ]);
}());
